export default __webpack_public_path__ + "static/GameController-60c2aefb1171ec81570dd226c43f07a6.png";